var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeroOverlayOptimized(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1813.3,
    height: 884.05,
    viewBox: "0 0 479.78 233.91",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-27.718 -23.654)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333 0 0 1.3333 187.15 93.372)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "text-background",
    x: -119.46,
    y: -52.174,
    width: 359.61,
    height: 175.2,
    opacity: 0.53101,
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.23
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-26.877 4.1715)",
    fill: "#f32113"
  }, /*#__PURE__*/React.createElement("g", {
    id: "First",
    strokeWidth: 0.66418,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    },
    "aria-label": "First"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-82.946 35.892h3.3475v-19.527h15.808v-2.9755h-15.808v-16.241h20.395v-2.8515h-23.742z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-52.086 35.892h3.2855v-30.437h-3.2855zm-0.06199-36.946h3.4095v-3.7814h-3.4095z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-39.923 35.892h3.2855v-24.486c2.1697-1.8597 5.3931-3.4095 8.8646-3.4095 0.49592 0 1.3638 0.06199 2.0457 0.18597v-2.9755c-0.43393-0.12398-1.1778-0.18597-1.7977-0.18597-3.7814 0-7.1909 1.9837-9.0506 3.9674h-0.18597v-3.5954h-3.1615z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-12.14 36.326c6.9429 0 10.414-3.3475 10.414-8.4927 0-5.3312-2.4796-7.1289-8.0587-8.6786l-3.3475-0.92985c-3.7814-1.1158-5.2072-2.4176-5.2072-5.5791 0-3.1615 2.3556-4.8972 7.0049-4.8972 3.1615 0 6.137 0.74388 7.9967 1.6117v-2.6656c-1.7357-0.86786-4.2773-1.7977-8.1827-1.7977-6.633 0-9.9184 3.2855-9.9184 7.9967 0 4.9592 2.7276 6.9429 7.2529 8.1827l3.2235 0.99184c4.4013 1.2398 5.9511 2.4796 5.9511 6.013 0 3.1615-2.0457 5.4551-7.5008 5.4551-4.3393 0-6.8189-0.92985-9.2365-2.0457v2.6656c2.2316 1.2398 5.5171 2.1697 9.6085 2.1697z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.354 36.14c2.3556 0 3.8434-0.49592 4.8972-1.0538v-2.1697c-1.2398 0.30995-2.7276 0.55791-4.0914 0.55791-3.7814 0-4.8352-1.3638-4.8352-4.4013v-20.953h8.3067v-2.6656h-8.3067v-7.1909h-3.2855v7.1909h-4.4633v2.6656h4.4633v21.387c0 4.6493 2.6656 6.633 7.3148 6.633z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "mission-to",
    strokeWidth: 0.27351,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    },
    "aria-label": "mission to"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m-83.278 59.998h1.353v-10.441c1.2509-0.71477 2.5017-1.1487 3.727-1.1487 1.7359 0 2.5017 0.68925 2.5017 2.4506v9.1389h1.3785v-9.4197c0-0.38291-0.05106-0.71477-0.12764-1.0211 1.404-0.76583 2.6549-1.1487 3.7781-1.1487 1.7359 0 2.5783 0.68925 2.5783 2.4506v9.1389h1.353v-9.4197c0-2.3996-1.353-3.3441-3.4207-3.3441-1.4295 0-2.9101 0.43397-4.5184 1.4295h-0.07658c-0.51055-0.97005-1.5572-1.4295-2.9612-1.4295-1.4295 0-2.8591 0.53608-4.1865 1.3785h-0.07658v-1.1487h-1.3019z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m-63.084 59.998h1.353v-12.534h-1.353zm-0.02553-15.214h1.404v-1.5572h-1.404z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m-54.96 60.177c2.8591 0 4.2886-1.3785 4.2886-3.4973 0-2.1954-1.0211-2.9357-3.3186-3.5739l-1.3785-0.38291c-1.5572-0.4595-2.1443-0.99558-2.1443-2.2975 0-1.3019 0.97005-2.0167 2.8846-2.0167 1.3019 0 2.5272 0.30633 3.2931 0.66372v-1.0977c-0.71477-0.35739-1.7614-0.7403-3.3696-0.7403-2.7315 0-4.0844 1.353-4.0844 3.2931 0 2.0422 1.1232 2.8591 2.9867 3.3696l1.3274 0.40844c1.8125 0.51055 2.4506 1.0211 2.4506 2.4762 0 1.3019-0.84241 2.2464-3.0888 2.2464-1.7869 0-2.808-0.38291-3.8036-0.84241v1.0977c0.91899 0.51055 2.272 0.89347 3.9568 0.89347z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m-44.739 60.177c2.8591 0 4.2886-1.3785 4.2886-3.4973 0-2.1954-1.0211-2.9357-3.3186-3.5739l-1.3785-0.38291c-1.5572-0.4595-2.1443-0.99558-2.1443-2.2975 0-1.3019 0.97005-2.0167 2.8846-2.0167 1.3019 0 2.5272 0.30633 3.2931 0.66372v-1.0977c-0.71477-0.35739-1.7614-0.7403-3.3696-0.7403-2.7315 0-4.0844 1.353-4.0844 3.2931 0 2.0422 1.1232 2.8591 2.9867 3.3696l1.3274 0.40844c1.8125 0.51055 2.4506 1.0211 2.4506 2.4762 0 1.3019-0.84241 2.2464-3.0888 2.2464-1.7869 0-2.808-0.38291-3.8036-0.84241v1.0977c0.91899 0.51055 2.272 0.89347 3.9568 0.89347z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m-37.556 59.998h1.353v-12.534h-1.353zm-0.02553-15.214h1.404v-1.5572h-1.404z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m-27.773 60.202c3.2675 0 5.6416-2.272 5.6416-6.3819v-0.30633c0-4.1099-2.2209-6.2798-5.6161-6.2798-3.2165 0-5.5905 2.2464-5.5905 6.3564v0.33186c0 4.1099 2.1954 6.2798 5.565 6.2798zm0.05106-1.0977c-2.4251 0-4.2376-1.4806-4.2376-5.131v-0.51055c0-3.3441 1.7103-5.131 4.1865-5.131 2.4251 0 4.2631 1.404 4.2631 5.131v0.48502c0 3.3952-1.7103 5.1566-4.2121 5.1566z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m-19.259 59.998h1.353v-10.441c1.2509-0.71477 2.7059-1.1487 4.0844-1.1487 2.0677 0 2.8336 0.68925 2.8336 2.4506v9.1389h1.3274v-9.4197c0-2.3996-1.2509-3.3441-3.6504-3.3441-1.5827 0-3.242 0.51055-4.5694 1.3785h-0.07658v-1.1487h-1.3019z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m4.4623 60.1c0.97005 0 1.5827-0.20422 2.0167-0.43397v-0.89347c-0.51055 0.12764-1.1232 0.22975-1.6848 0.22975-1.5572 0-1.9912-0.56161-1.9912-1.8125v-8.6283h3.4207v-1.0977h-3.4207v-2.9612h-1.353v2.9612h-1.838v1.0977h1.838v8.807c0 1.9146 1.0977 2.7315 3.0123 2.7315z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m13.958 60.202c3.2675 0 5.6416-2.272 5.6416-6.3819v-0.30633c0-4.1099-2.2209-6.2798-5.6161-6.2798-3.2165 0-5.5905 2.2464-5.5905 6.3564v0.33186c0 4.1099 2.1954 6.2798 5.565 6.2798zm0.05105-1.0977c-2.4251 0-4.2376-1.4806-4.2376-5.131v-0.51055c0-3.3441 1.7103-5.131 4.1865-5.131 2.4251 0 4.2631 1.404 4.2631 5.131v0.48502c0 3.3952-1.7103 5.1566-4.2121 5.1566z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Jupiter",
    transform: "translate(0 4.4224)",
    strokeWidth: 0.97071,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    },
    "aria-label": "Jupiter"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m36.787 55.706c10.963 0 15.674-6.1608 15.674-14.949v-50.804h-4.983v50.713c0 7.0668-3.3522 10.781-11.144 10.781-3.5334 0-7.1574-0.6342-9.513-1.6308v4.077c2.718 1.1778 5.9796 1.812 9.966 1.812z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.697 55.672c5.2548 0 10.691-1.9932 15.402-4.983h0.2718l0.453 4.1676h4.1676v-44.484h-4.8018v36.874c-4.3488 2.6274-9.2412 4.2582-14.224 4.2582-7.0668 0-9.966-2.4462-9.966-9.06v-32.072h-4.7112v32.797c0 8.5164 4.8924 12.503 13.409 12.503z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107.46 68.446h4.7112v-16.036c2.718 1.6308 6.795 3.171 12.14 3.171 12.503 0 20.294-6.8856 20.294-22.831v-0.906c0-17.033-7.9728-22.288-18.029-22.288-6.342 0-11.053 2.1744-14.315 4.53h-0.2718v-3.7146h-4.53zm16.58-16.761c-5.0736 0-9.3318-1.6308-11.869-3.3522v-30.713c2.718-1.9026 7.5198-3.8958 13.318-3.8958 8.7882 0 14.224 4.077 14.224 18.301v1.359c0 13.046-5.9796 18.301-15.674 18.301z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152.52 54.856h4.8018v-44.484h-4.8018zm-0.0906-53.997h4.983v-5.5266h-4.983z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m181.25 55.219c3.4428 0 5.6172-0.7248 7.1574-1.5402v-3.171c-1.812 0.453-3.9864 0.8154-5.9796 0.8154-5.5266 0-7.0668-1.9932-7.0668-6.4326v-30.623h12.14v-3.8958h-12.14v-10.51h-4.8018v10.51h-6.5232v3.8958h6.5232v31.257c0 6.795 3.8958 9.6942 10.691 9.6942z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m213.67 55.581c6.795 0 11.687-1.9932 14.405-3.624v-3.7146c-3.5334 1.812-7.7916 3.171-13.771 3.171-11.234 0-16.852-5.5266-16.852-18.392h32.072v-2.718c0-13.318-5.5266-20.747-17.576-20.747-10.419 0-19.298 7.0668-19.298 22.559v0.9966c0 14.315 7.0668 22.469 21.019 22.469zm-1.9026-42.129c8.6976 0 12.865 5.2548 12.865 15.764h-27.089c0.7248-11.325 7.248-15.764 14.224-15.764z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m236.97 54.856h4.8018v-35.787c3.171-2.718 7.8822-4.983 12.956-4.983 0.7248 0 1.9932 0.0906 2.9898 0.2718v-4.3488c-0.6342-0.1812-1.7214-0.2718-2.6274-0.2718-5.5266 0-10.51 2.8992-13.228 5.7984h-0.2718v-5.2548h-4.6206z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroOverlayOptimized);
export default __webpack_public_path__ + "static/media/hero-overlay-optimized.7b8f7430.svg";
export { ForwardRef as ReactComponent };